import SalesManagerFormMixin from "../SalesManager/salesManagerFormMixin";
import AccountManagerFormMixin from "../AccountManager/accountManagerFormMixin";

export default {

  mixins: [
    SalesManagerFormMixin,
    AccountManagerFormMixin
  ],

  data() {
    return {
      formErrors: {
        legal_title: [],
        sales_manager_id: null,
        account_manager_id: null,
        account_manager_change_date: null,
        channel: [],
      },
    }
  },

  methods: {
    async onSubmit(evt, close = true) {
      evt.preventDefault();

      if (!this.form.legal_title) {
        this.formErrors.legal_title = ['Заполните официальное название']
        return;
      }

      /*if (typeof this.form.channel !== 'undefined' && !this.form.channel) {
        this.formErrors.channel = ['Укажите канал продаж']
        return;
      }*/

        if (!this.form.account_manager_change_date) {
            this.formErrors.account_manager_change_date = 'Внесите дату изменения Аккаунт Менеджера'
            return;
        }

      // if (!this.form.sales_manager_id) {
      //   this.formErrors.sales_manager_id = 'Выберите Сейлз Менеджера'
      //   return;
      // }
      //
      // if (!this.form.account_manager_id) {
      //   this.formErrors.account_manager_id = 'Выберите Аккаунт Менеджера'
      //   return;
      // }

      let response = await this.sendForm();

      if (close && response.status === true) {
        window.location.href = '/advertisers';
        return;
      }

      if (!close && response.status === true) {
        this.formErrors = {
          legal_title: [],
          sales_manager_id: null,
          account_manager_id: null,
          account_manager_change_date: null,
          channel: [],
        }

        this.form = {
          legal_title: null,
          title: null,
          sales_manager_id: null,
          account_manager_id: null,
          channel: null,
          account_manager_change_date: null
        };
        return;

      }
      this.formErrors = response.errors
    },
  },
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/Advertiser/createUpdateMixin.js